import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ProductVariantService } from '../../product-variant.service';

@Component({
  selector: 'itpx-product-variant-edit-delivery',
  templateUrl: './product-variant-edit-delivery.component.html',
  styleUrls: ['./product-variant-edit-delivery.component.css']
})
export class ProductVariantEditDeliveryComponent implements OnInit {

  @Input() form: FormGroup;
  
  private accessDurationTypeDict: Observable<{key: string, value: string}[]> = this.service.getAccessDurationTypes().map(_ => _.data);
  private freightClassDict: Observable<{key: string, value: string}[]> = this.service.getFreightClassDict().map(_ => _.data);

  constructor(private service: ProductVariantService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-variants/common/delivery/product-variant-edit-delivery.component.ts